export default __webpack_public_path__ + "static/media/1616.78785bfd.png";